import img from './img-empty.svg';
import './NotFoundData.scss';

const NotFoundData = () => (
  <div className="style-content content-img-text">
    <img alt="img-box-null" src={img} />
    <p className="text-not-found">No se encontró ninguna coincidencia.</p>
  </div>
);

export default NotFoundData;
